import BeneficiaryInformation from './BeneficiaryInformation';
import BeneficiaryForOfficialUse from './BeneficiaryForOfficialUse';
import BeneficiaryContactDetail from './BeneficiaryContactDetail';
import BeneficiaryAppInformation from './BeneficiaryAppInformation';

export default {};

export { BeneficiaryInformation };
export { BeneficiaryForOfficialUse };
export { BeneficiaryContactDetail };
export { BeneficiaryAppInformation };



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/components/index.js
// module id = 868
// module chunks = 0